import { render, staticRenderFns } from "./PublicationCapacityRow.vue?vue&type=template&id=7bc7247b&"
import script from "./PublicationCapacityRow.vue?vue&type=script&lang=js&"
export * from "./PublicationCapacityRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports